import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegistrationService } from '../../registration.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler } from '../../shared/ErrorHandler';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  formSubmitted: boolean = false;
  data: any;
  register:any={};

  constructor(private router: Router,private userService: RegistrationService,private errorHandler:ErrorHandler) { }

  ngOnInit() {
  }


  // onSubmit(fp: NgForm) {
  //   debugger;
  //     document.getElementById('loader-spinner').style.display = "block";
  //     this.data = this.userService.forgetPassword(fp.value);
  //     this.data.subscribe(
  //       (response) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //         this.router.navigate(['/login']);
  //       }, (error) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //        //this.errorHandler.HandlerError(error);
  //       });
   
  // }

  Save(rf:NgForm)
  { 
    debugger;
    
    if (!rf.invalid )
    {    
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.forgetPassword(rf.value).subscribe(
      (data:any) => {
        debugger;        
        document.getElementById('loader-spinner').style.display = "none";        
        if (data!=null && data!="" )
        {
          this.router.navigateByUrl("/CreatePasswordph/"+data +"/true");
        }
        else
        {
          swal('','An email is sent to create a new password!','success');
        }
        //this.router.navigate(['/login']);

        
      }, (error)=>{        
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
        
      });
    }
    else
    {
      this.formSubmitted = true;
    }
  } 
}



// WEBPACK FOOTER //
// ./src/app/registration/forgot-password/forgot-password.component.ts